import React from 'react';
import PropTypes from 'prop-types';
// import { useStaticQuery, graphql } from "gatsby"
import styled from 'styled-components';
import { Breakpoints, KineduPalette } from 'kinedu-react-components';

import BlueShape from './assets/images/backblue_new_brand.svg';
import './styles/normalize.css';
import './styles/global.css';
import ClassroomsLogo from './Logo';

const StyledLayout = styled.div`
  display: grid;
  grid-template-columns: auto repeat(4, 60px) auto;
  grid-column-gap: 20px;
  height: 100vh;

  background-image: url(${BlueShape});
  background-repeat: no-repeat;
  background-size: cover;

  ${Breakpoints.desktop} {
    grid-template-columns: auto repeat(12, 60px) auto;
  };
`;

const Header = styled.div`
  position: absolute;
  width: 100%;
  height: auto;
  padding: 20px 60px;
  box-sizing: border-box;
`;

const Canvas = styled.main`
  display: flex;
  flex-direction: column;
  align-self: center;

  margin: 0;
  padding: 20px 50px 30px;
  background-color: white;

  border: 1px solid ${KineduPalette.shadeMediumDark};
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);

  ${Breakpoints.desktop} {
    grid-column: 4 / 12;
  }

`;

const Layout = ({ children }) => {
  return (
    <StyledLayout>
      <Header>
        <ClassroomsLogo altVersion />
      </Header>
      <Canvas>
        {children}
      </Canvas>
    </StyledLayout>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
